import { Link } from 'react-router-dom';
import { PostEditor } from '../components';
import './AdminEditPage.css';

export function AdminNewPage() {
  return (
    <div className="admin-edit-page">
      <Link to="/admin" className="admin-edit-page__back text-sans text-small">
        &larr; Back to admin
      </Link>
      <PostEditor />
    </div>
  );
}
